<script setup lang="ts">
import type { BadgeProps } from '@nuxt/ui'
import type { ReleaseState } from '@/types'
import { computed } from 'vue'

const props = defineProps<{
  state: ReleaseState
}>()

const config = computed<{ label: string, color: BadgeProps['color'], icon: string }>(() => {
  switch (props.state) {
    case 'published':
      return { label: 'Published', color: 'success', icon: 'i-lucide-check-circle' }
    case 'yanked':
      return { label: 'Yanked', color: 'error', icon: 'i-lucide-x-circle' }
    default:
      return { label: 'Draft', color: 'neutral', icon: 'i-lucide-pencil' }
  }
})
</script>

<template>
  <UBadge :color="config.color" :icon="config.icon" variant="subtle" size="sm">
    {{ config.label }}
  </UBadge>
</template>
